define.alias("shared/components/shared/mobile/open-app", "settings/components/shared/mobile/open-app");